<template>
    <div>
        <app-file v-for="(file, index) in files" :key="file.name" :file="file" :index="index" :removeable="removeable" v-on:remove="remove"></app-file>
    </div>
</template>

<script>
import File from '@/components/shared/File';

export default {
    props: {
        files: {
            type: Array,
            required: true,
        },
        removedFiles: {
            type: Array,
            required: false,
            default: () => [],
        },
        removeable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        remove({ fileName }) {
            const index = this.files.map(file => file.fileName).indexOf(fileName);
            const removed = this.files.splice(index, 1);
            this.removedFiles.push(removed[0]);
            this.$emit('update:files', this.files);
            this.$emit('update:removedFiles', this.removedFiles);
            // this.$store.dispatch('approveDemand', this.form);
        },
    },
    components: {
        appFile: File,
    },
};
</script>




// WEBPACK FOOTER //
// src/components/shared/Files.vue